import { z } from "zod";
export const UpdateRecordingSink = z.object({
    enabled: z.boolean(),
    retentionDays: z.number().min(1).max(365),
    channelId: z.string(),
});
//# sourceMappingURL=sink.recording.js.map